import * as ChannelService from '@channel.io/channel-web-sdk-loader';
import { atom, useAtom } from 'jotai';

const initChannelAtom = atom(false);
const channelUIOpenAtom = atom(false);

const useChannelIOApi = () => {
  const [isChannelInitialized, setIsChannelInitialized] = useAtom(initChannelAtom);
  const [isChannelUIOpen, setIsChannelUIOpen] = useAtom(channelUIOpenAtom);

  return {
    ...ChannelService,
    isChannelInitialized,
    setIsChannelInitialized,
    isChannelUIOpen,
    setIsChannelUIOpen,
  };
};

export default useChannelIOApi;
